// @ts-nocheck
/* eslint-disable */
import { takeLatest, call, put } from 'redux-saga/effects';
import * as types from 'appRedux/actions/variation_register';
import {
  SHOW_FULLSCREEN_LOADER,
  HIDE_FULLSCREEN_LOADER,
} from 'appRedux/actions/loader';
import { UPDATE_TAB_EDITED_STATE } from 'appRedux/actions/project_budget';
import { API_URL as API_URI } from 'config/constants';
import * as services from 'utils/apiHelper';
import { successToast } from 'utils/toastHandler';
import getQueryParams from 'utils/getQueryParams';

function* getVariationTasksRequest(action) {
  const token = localStorage.getItem('token');
  const { payload } = action;
  const query = getQueryParams(payload);
  const data = yield call(
    services.fetchGetApi,

    `${API_URI}/variation_get/?${query}`,

    token,
  );

  if (data) {
    yield put({
      type: types.GET_VARIATION_TASKS_SUCCESS,
      payload: data,
    });
  }
}

function* postVariationTasksRequest(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const payload = action.payload.map((data) => ({
    id: data.id,
    claim_status: data.claim_status,
    commenced: data.commenced,
    est_cost: data.est_cost,
    claim_amount: data.claim_amount,
    // claim_amount_change: data.claim_amount_change
    //   ? data.claim_amount_change
    //   : 0,
  }));

  const data = yield call(
    services.fetchPostApi,
    `${API_URI}/variation-post/`,
    payload,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({
      type: types.POST_VARIATION_TASKS_SUCCESS,
    });
    successToast('Variation was registered successfully.');
  }
}

function* addNoteRequest(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;

  const data = yield call(
    services.postFormData,
    `${API_URI}/variation-note/`,
    'post',
    payload,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({
      type: types.ADD_VARIATION_REGISTER_NOTE_SUCCESS,
    });
    successToast('Note was added successfully.');
  }
}

function* updateNoteRequest(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;

  const data = yield call(
    services.postFormData,
    `${API_URI}/variation-note/${payload.id}/`,
    'put',
    payload,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({
      type: types.UPDATE_VARIATION_REGISTER_NOTE_SUCCESS,
    });
    successToast('Note was updated successfully.');
  }
}

function* deleteNoteRequest(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;
  const data = yield call(
    services.fetchDelApi,
    `${API_URI}/variation-note/${payload.id}/`,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({
      type: types.DELETE_VARIATION_REGISTER_NOTE_SUCCESS,
      payload,
    });
    successToast('Note was deleted successfully.');
  }
}

function* variationRegisterWatcher() {
  yield takeLatest(types.GET_VARIATION_TASKS_REQUEST, getVariationTasksRequest);
  yield takeLatest(
    types.POST_VARIATION_TASKS_REQUEST,
    postVariationTasksRequest,
  );
  yield takeLatest(types.ADD_VARIATION_REGISTER_NOTE_REQUEST, addNoteRequest);
  yield takeLatest(
    types.UPDATE_VARIATION_REGISTER_NOTE_REQUEST,
    updateNoteRequest,
  );
  yield takeLatest(
    types.DELETE_VARIATION_REGISTER_NOTE_REQUEST,
    deleteNoteRequest,
  );
}

export default variationRegisterWatcher;
